// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    adyen: {
        environment: 'test',
        originKey:
            'pub.v2.7614568265920033.aHR0cHM6Ly9hcHAuZ29waG90by5kZXY.d6jHlHeFcz4AH2Iga1MFLPyFeyxMaKm9ARNwtpbih7A',
    },
    fingerprintjs: {
        apiKey: '2hIKIRVUKiKeGECKncZD',
    },
    http: {
        baseUri: 'https://api.us1.gophoto.app',
        globalApiUri: 'https://api.gophoto.app',
        globalCMSUri: 'https://cms.gophoto.app',
        authorization: {
            headerName: 'Authorization',
            tokenPrefix: 'Bearer',
        },
    },
    linkpage: {
        rootDomain: 'gophoto.pro',
    },
    logoutUrl: 'https://cms.gophoto.app/',
    production: true,
    recaptcha: {
        siteKey: '6Lf0Pt0UAAAAADX0M9HQ5wbyZTUWie3pxJRkfX_s',
    },
    regionSwitches: [{ label: 'Switch to EU region', url: 'https://cms.gophoto.pro' }],
    serverTimezone: 'UTC',
};
